import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { QuantityPicker } from 'baby-design'

import {
  getCartedQuantity,
  getHandleDecreaseQuantity,
  getHandleIncreaseQuantity,
  getHandleRemoveFromCart,
} from 'src/routes/(subdomains)/(my)/[slug]/utils/cartedRegItemHelpers/cartedRegItemHelpers'
import useGetCart from 'src/routes/(subdomains)/(my)/[slug]/hooks/useGetCart'
import { InCartBadgeProps } from './InCartBadge.types'
import css from './InCartBadge.styles.scss'

const InCartBadge: React.FC<InCartBadgeProps> = ({ regItem }) => {
  const { cart } = useGetCart()
  const quantityInCart = getCartedQuantity(regItem, cart)
  const onMinusClick = getHandleDecreaseQuantity(regItem)
  const onPlusClick = getHandleIncreaseQuantity(regItem)
  const onTrashClick = getHandleRemoveFromCart(regItem)

  if (quantityInCart < 1) return null

  return (
    <div className={css.InCartBadge} data-testid="InCartBadge">
      <QuantityPicker
        className={css.InCartBadge__QuantityPicker}
        size="sm"
        type="cart"
        value={quantityInCart}
        variant="outline"
        onMinusClick={onMinusClick}
        onPlusClick={onPlusClick}
        onTrashClick={onTrashClick}
      >
        {quantityInCart}
      </QuantityPicker>
    </div>
  )
}

export default InCartBadge
